module.exports = __webpack_public_path__ + "static/img/6.77c7f10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/6.png
// module id = C4Lp
// module chunks = 0